<template>
    <div class="w-full">
        <div :class="$helper.isSSOLoggedIn ? 'mobile:!pt-[25px]' : ''"
            class="relative border-1 rounded-2xl min-w-full flex flex-col-reverse desktop:grid desktop:grid-cols-6 largeDesktop:grid-cols-6 desktop:gap-[15px] largeDesktop:gap-[30px] p-[5px] tablet:p-[10px] laptop:p-[20px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]">
            <div v-if="$helper.isSSOLoggedIn" class="absolute -top-[18px] left-2.5 z-10">
                <button @click="SSOButtonClicked"
                    class="transform lg:hover:scale-[1.15] active:scale-[0.98] mobile:flex laptop:hidden justify-center items-center w-[35px] h-[35px] rounded-full bg-customYellow-100 focus:outline-none text-white transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]">
                    <img src="../../../assets/images/arrow-icon.png" alt="Toggle Icon"
                        class="rotate-[180deg] min-h-[22px] min-w-[22px] max-h-[22px] max-w-[22px] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]">
                </button>
            </div>
            <div class="mt-[10px] desktop:mt-0 w-full laptop:col-span-5 desktop:col-span-3 largeDesktop:col-span-3 accordion rounded-0 flex flex-col gap-[10px] laptop:gap-[15px]"
                id="accordionExample">
                <!-- STEP 1 -->
                <div ref="serviceDetailsRef"
                    class="accordion-item border-0 p-[20px_15px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px] first:!rounded-t-[10px]">
                    <button class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-days font-medium text-[#333333]
                        [&:not(.collapsed)]:!bg-transparent
                        [&:not(.collapsed)]:!shadow-none
                        [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button" @click="toggleAccordion(1)">
                        <p class="m-0 text-[16px] font-normal font-days text-[#333]">
                            <span class="text-[#2359A8] tracking-[0.2px]">Step 1:</span>
                            Service Details
                        </p>

                        <div v-if="openAccordion == 1" class="accordionIcon ">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt="" />
                        </div>
                        <div v-else-if="step1Completed"
                            class="accordionIcon transition-transform duration-300 transform lg:hover:scale-[1.2] active:scale-[0.98] w-[30px] h-[30px] flex items-center justify-center rounded-full shadow-[0_0_5px_0_rgba(0,0,0,0.15)] hover:bg-[#EFEFEF]/50">
                            <img src="../../../assets/images/accordion-yellow-edit-icon.svg" alt="" />
                        </div>
                        <div v-else class="accordionIcon">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt="" />
                        </div>

                    </button>

                    <div v-show="openAccordion == 1" class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <serviceDetail ref="serviceDetailRef" @submit-detail="handleStep1Complete" />
                        </div>
                    </div>
                </div>

                <!-- STEP 2 -->
                <div ref="billingRef"
                    class="accordion-item border-0 p-[20px_15px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px]">
                    <button class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-days font-medium text-[#333333]
              [&:not(.collapsed)]:!bg-transparent
              [&:not(.collapsed)]:!shadow-none
              [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button"
                        :class="{ '!cursor-not-allowed': !step1Completed }" @click="toggleAccordion(2)">
                        <p class="m-0 text-[16px] font-normal font-days text-[#333]">
                            <span class=" text-[#2359A8] tracking-[0.2px]"
                                :class="{ '!text-[#999]': !step1Completed }">Step 2:</span>
                            Billing Information
                        </p>

                        <div v-if="openAccordion == 2" class="accordionIcon ">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt="" />
                        </div>
                        <div v-else-if="step2Completed"
                            class="accordionIcon transition-transform duration-300 transform lg:hover:scale-[1.2] active:scale-[0.98] w-[30px] h-[30px] flex items-center justify-center rounded-full hover:bg-[#EFEFEF]/50 shadow-[0_0_5px_0_rgba(0,0,0,0.15)]">
                            <img src="../../../assets/images/accordion-yellow-edit-icon.svg" alt="" />
                        </div>
                        <div v-else class="accordionIcon">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt="" />
                        </div>
                    </button>

                    <div v-show="openAccordion == 2 && step1Completed" class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <billingInformation ref="billingInformationRef" @submit-detail="handleStep2Complete" />
                        </div>
                    </div>
                </div>

                <!-- STEP 3 -->
                <div ref="paymentRef"
                    class="accordion-item border-0 p-[20px_15px] shadow-[0px_4px_10px_0px_#0000001A] rounded-[10px] last:!rounded-b-[10px]">
                    <button class="accordion-button after:!hidden flex justify-between gap-[5px] px-0 pt-0 !pb-0 text-[16px] font-days font-medium text-[#333333]
              [&:not(.collapsed)]:!bg-transparent
              [&:not(.collapsed)]:!shadow-none
              [&:not(.collapsed)_.accordionIcon]:rotate-0" type="button"
                        :class="{ '!cursor-not-allowed': !step2Completed }" @click="toggleAccordion(3)">
                        <p class="m-0 text-[16px] font-normal font-days text-[#333]">
                            <span class="text-[#2359A8] tracking-[0.2px]"
                                :class="{ '!text-[#999]': !step2Completed }">Step 3:</span>
                            Payment Information
                        </p>
                        <div v-if="openAccordion == 3" class="accordionIcon ">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-0" alt="" />
                        </div>
                        <div v-else class="accordionIcon">
                            <img src="../../../assets/images/accordion-purple-angle-icon.svg"
                                class="transition-transform duration-300  rotate-180" alt="" />
                        </div>
                    </button>

                    <div ref="paymentRef" v-show="openAccordion == 3 && step2Completed"
                        class="!mt-[15px] !border-t !border-[#EFEFEF]">
                        <div class="accordion-body pb-0 px-0 !pt-[15px]">
                            <paymentInformation :stripe_id="stripId" ref="paymentInformationRef"
                                @submit-detail="handleStep3Complete" />
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="mt-0 w-full laptop:col-span-5 desktop:col-span-3 largeDesktop:col-span-3 mobile:p-[10px] tablet:p-[20px] rounded-[20px] shadow-[0px_4px_10px_0px_#0000001A] bg-white">
                <div class="relative tablet:flex flex-row items-center justify-between gap-[10px] pb-2.5">
                    <div class="flex flex-col gap-[5px]">
                        <div class="flex items-center gap-[5px] largeDesktop:gap-[10px]">
                            <div class="flex items-center justify-center gap-2 rounded-full px-2 py-0.5 min-w-[55px] largeDesktop:min-w-[75px] max-w-[85px] h-[30px] largeDesktop:h-[40px] bg-customBlue-100"
                                :class="{ '!bg-[#ccc]': modalCartCount == 0, '!min-w-[85px]': modalCartCount > 19 }">
                                <img src="../../../assets/images/cart-check-white.png" alt="Cart Icon"
                                    class="h-[20px] w-[20px] largeDesktop:w-[30px] largeDesktop:h-[30px]">
                                <span
                                    class="text-[16px] largeDesktop:text-[20px] font-poppins font-medium text-white">{{
                                        modalCartCount
                                    }}</span>
                            </div>
                            <div class="flex items-center gap-[5px] leading-[1]">
                                <h4 class="min-w-max text-[20px] mb-[3px] font-poppins font-medium text-[#333333]">
                                    Cart</h4>
                                <p class="text-[12px] largeDesktop:block m-0 font-poppins font-normal text-[#666] ml-1">
                                    Check your plans before checkout</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-between gap-[5px] sm:gap-[10px] py-2.5 flex-row">
                    <span v-if="cartDetails.has_repair == true" @click="openCoverageModal()"
                        :class="cartDetails.has_repair == true ? '' : 'ml-auto'"
                        class="CustomYellowBtn group w-full tablet:w-[250px] h-[35px] largeDesktop:h-[40px] flex justify-center items-center gap-1 font-poppins font-medium text-[11px] tablet:text-[14px] rounded-full cursor-pointer border-[1px] !border-[#F5B134] !text-[#333] bg-[#F5B134]">
                        Review Coverage Amount
                    </span>
                    <div class="flex justify-end w-full tablet:w-auto">
                        <div v-if="cartDetails.has_repair == true" @click="optionalCoverageClick"
                            class="lg:hover:-translate-y-1 lg:hover:scale-[1.02] active:translate-y-0 active:scale-[0.98] group cursor-pointer flex items-center mobile:w-full justify-center tablet:justify-between gap-[3px] tablet:gap-[5px] min-w-[160px] laptop:min-w-[170px] largeDesktop:min-w-[190px] tablet:w-auto rounded-full shadow-[0px_0px_10px_0px_#0000001A] p-[5px] pr-[10px] transition duration-300 bg-[#fff] laptop:hover:bg-[#B6CE35]">
                            <div
                                class="min-w-[25px] min-h-[25px] largeDesktop:min-w-[30px] largeDesktop:min-h-[30px] flex items-center justify-center rounded-full shadow-[0px_0px_10px_0px_#0000001A] border-[2px] border-[#fff] bg-[#B6CE35] text-[#fff]">
                                <i class="fa fa-plus !text-[13px] largeDesktop:!text-[15px]"></i>
                            </div>
                            <p
                                class="m-0 font-poppins text-[11px] tablet:text-[14px] laptop:text-[12px] largeDesktop:text-[14px] transition duration-300 text-[#000000]  laptop:group-hover:text-[#fff]">
                                Optional Coverages</p>
                        </div>
                    </div>
                </div>

                <div
                    class="flex flex-col gap-[10px] desktop:max-h-[96vh] largeDesktop:max-h-[61vh] laptop:pr-2 overflow-y-auto customScrollbar tablet:mt-2.5">
                    <bundleCartCard v-for="(bundle, index) in cartDetails.bundles" :key="index" :bundle="bundle"
                        :updateCart="updateBundleCart" :updateCard="updateCardCart" :cartDetails="cartDetails" />
                    <cartCard v-for="(plan, index) in cartDetails.items" :key="index" :plan="plan"
                        :updateCart="updateCart" :updateCard="updateCardCart" />
                </div>
                <div v-if="cartDetails.promo_code_applicable == '1'">
                    <div v-if="$helper.isEmpty(cartDetails.promo_code)" @click="openVoucherModal"
                        class="group CustomYellowBtn flex items-center gap-[10px] mt-[20px] cursor-pointer w-max rounded-full p-[5px] !pr-[15px] text-[16px] font-roboto border-[1px] border-[#F8B134] text-[#000] bg-[#F8B134]">
                        <div class="rounded-full w-[30px] h-[30px] flex items-center justify-center bg-[#fff]">
                            <img src="../../../assets/images/promo-code-large-icon-yellow.svg" alt=""
                                class="w-[15px] h-[12px]">
                        </div>
                        <p class="font-poppins text-[15px] font-normal">Enter Promo Code</p>
                        <div class="filter invert-0 brightness-0">
                            <img src="../../../assets/images/arrow-white-icon.svg" alt="">
                        </div>
                    </div>
                    <div v-else class="mt-[20px] rounded-[10px] p-[10px] laptop:p-[15px] bg-[#2459A8]/5">
                        <div class="rounded-[10px] pb-[3px] bg-[#2459A8]">
                            <h6 class="p-[15px] text-[16px] laptop:text-[20px] font-days uppercase text-[#F8B134]">{{
                                cartDetails.promo_code.title }}
                            </h6>
                            <div class="rounded-[10px] border border-[#efefef] bg-[#FFFFFF]">
                                <div class="p-[10px]">
                                    <div class="flex items-center justify-between gap-[15px] w-full">
                                        <div class="flex items-center gap-[10px]">
                                            <div
                                                class="rounded-full w-[40px] h-[40px] flex items-center justify-center bg-[#F8B134]">
                                                <img src="../../../assets/images/promo-code-large-icon-white.svg" alt=""
                                                    class="w-[20px] h-[16px]">
                                            </div>
                                            <div>
                                                <p class="font-poppins font-bold text-[14px] text-[#333]">
                                                    {{ cartDetails.promo_code.promo_code }}
                                                </p>
                                                <p class="font-poppins font-bold text-[14px] text-[#FE5000]">
                                                    −${{ $helper.formatAmount(cartDetails.promo_code.discount_amount ??
                                                        0)
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div @click="removeVoucher"
                                            class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 group flex items-center justify-center cursor-pointer w-[30px] h-[30px] rounded-full transition-all shadow-[0_0_5px_0_#00000026] bg-white hover:!bg-[#FE5000]">
                                            <img src="../../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                                                class="w-[20px] h-[20px] group-hover:hidden object-contain">
                                            <img src="../../../assets/images/trash-icon-white-updated.png"
                                                alt="Cart Icon" class="w-[20px] h-[20px] hidden group-hover:!block">
                                        </div>
                                    </div>
                                    <div
                                        class="my-[10px] border-spacing-y-4 border-[1px] border-dashed border-[#F5B134]">
                                    </div>
                                    <div class=" overflow-hidden">
                                        <button @click="toggle"
                                            class="w-full flex justify-between items-center text-left font-semibold font-poppins text-[14px] text-[#2459A8]">
                                            Offer Details
                                            <span
                                                class="transition-transform duration-300 w-[30px] h-[30px] rounded-full flex items-center justify-center text-[#fff] bg-[#2459A8]"
                                                :class="isOpen ? '-rotate-90' : 'rotate-90'">
                                                <img src="../../../assets/images/angle-right-icon.png" alt="Arrow Icon"
                                                    class="w-[16px] h-[16px] object-contain">
                                            </span>
                                        </button>
                                        <div ref="content"
                                            class="transition-all duration-300 ease-in-out overflow-hidden"
                                            :style="{ height: isOpen ? contentHeight + 'px' : '0px' }">
                                            <div class="pt-[10px] text-[13px] font-poppins text-[#333333]">
                                                {{
                                                    cartDetails.promo_code.description }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col gap-[5px] mt-[10px]">
                    <div class="flex items-center justify-between p-[13px] rounded-[10px] bg-[#2459A8]/5">
                        <h6 class="m-0 text-[14px] font-poppins font-medium text-[#333] mobile:mb-2 laptop:mb-0">
                            Sub Total</h6>
                        <h2 class="m-0 text-[14px] laptop:text-[16px] font-poppins font-semibold text-[#333]">
                            ${{ $helper.formatAmount(checkoutTotalResponse.amount ?? 0) }}/mo
                        </h2>
                    </div>
                    <div v-if="checkoutTotalResponse.discount_amount > 0"
                        class="flex items-center justify-between p-[13px] rounded-[10px] bg-[#E5D2B4]/15">
                        <h6 class="m-0 text-[14px] font-poppins font-medium text-[#333] mobile:mb-2 laptop:mb-0">
                            Discount</h6>
                        <h2 class="m-0 text-[14px] laptop:text-[16px] font-poppins font-semibold text-[#FE5000]">
                            -${{ $helper.formatAmount(checkoutTotalResponse.discount_amount ?? 0) }}
                        </h2>
                    </div>
                    <div class="flex items-center justify-between p-[13px] !pb-0">
                        <h6
                            class="m-0 text-[16px] laptop:text-[18px] font-poppins font-medium text-customBlue-100 !mb-2 laptop:mb-0">
                            Total Amount</h6>
                        <div>
                            <h2 class="m-0 text-[22px] laptop:text-[30px] font-poppins font-semibold text-[#333333]">${{
                                $helper.formatAmount(checkoutTotalResponse.total_amount ?? 0) }}
                            </h2>
                        </div>
                    </div>
                    <!-- <div class="flex items-center justify-between">
                        <h6
                            class="m-0 text-[16px] laptop:text-[18px] font-poppins font-medium text-customBlue-100 !mb-2 laptop:mb-0">
                            Voucher Amount</h6>
                        <h2 class="m-0 text-[22px] laptop:text-[30px] font-poppins font-semibold text-[#333333]">${{
                            $helper.formatAmount(cartItemsTotal) }}/mo
                        </h2>
                    </div> -->
                </div>
            </div>
        </div>
    </div>

    <!-- coverage Modal -->
    <coverageModal ref="coverageModalRef" />

    <!-- Addons Modal -->
    <addonsModal ref="addonsModalRef" :isFromCheckout="true" :isWatcherDisolve="isWatcherDisolve" />

    <!-- voucherModal -->
    <voucherModal ref="voucherModalRef" @applyVoucher="handleVoucher" />

        <!-- planDetailModal -->
    <div class="modal fade bg-[#00000063]" ref="planDetailModal" id="planDetailModal" tabindex="-1" aria-labelledby="planDetailModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-3 tablet:!px-0 mobile:!min-w-full mobile:!max-w-full tablet:!w-[500px] tablet:!min-w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-3 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <span
                                class="text-[13px] font-poppins font-normal m-0 rounded-full w-max px-[15px] block bg-customYellow-100 text-white">{{
                                    addonPlanDetails?.trade_name ?? '' }}</span>
                            <h4 class="text-[20px] font-medium font-poppins m-0 text-white">{{
                                addonPlanDetails?.plan_name ?? '' }}</h4>
                        </div>
                    </div>
                    <div ref="scrollBox" class="max-h-[550px] overflow-y-auto customScrollbar px-2.5 mt-[25px] py-1">
                        <!-- <customAccordion :items="getCoveredData()" /> -->
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden">
                            <h4
                                class="w-full text-[16px] font-medium font-poppins mb-2.5 text-left bg-transparent !text-customBlue-100">
                                Included:</h4>
                            <div v-html="addonPlanDetails?.covered" class="bundleDescription">
                            </div>
                        </div>
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.not_covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden mt-3">
                            <h4
                                class="w-full text-[16px] font-poppins mb-1.5 text-left bg-transparent !text-customBlue-100">
                                Excluded:</h4>
                            <div v-html="addonPlanDetails?.not_covered" class="bundleDescription excludedItems">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import serviceDetail from '../../../components/nest_components/partner-checkout/service_detail.vue';
import billingInformation from '../../../components/nest_components/partner-checkout/billing-information.vue';
import paymentInformation from '../../../components/nest_components/partner-checkout/payment-information.vue';
import cartCard from '../../../components/partnerCartCard/cartCard.vue';
import bundleCartCard from '../../../components/partnerCartCard/bundleCartCard.vue';
import addonsModal from '../../../components/nest_components/addons/addons_modal.vue';
import coverageModal from "../../../components/nest_components/coverage/coverage_modal.vue";
import voucherModal from "../../../components/nest_components/voucher/voucherModal.vue";
import { Modal } from "bootstrap";

export default {
    components: {
        serviceDetail,
        billingInformation,
        paymentInformation,
        cartCard,
        bundleCartCard,
        addonsModal,
        coverageModal,
        voucherModal
    },
    data() {
        return {
            openAccordion: 1, // Start with Step 1 open
            step1Completed: false,
            step2Completed: false,
            dataForm: {},
            stripId: null,
            updateCard: null,
            updateCardCart: null,
            selectedPlan: {},
            selectedType: 'bundle',
            isCartUpdate: false,
            isWatcherDisolve: true,
            isOpen: false,
            contentHeight: 0,
        };
    },
    computed: {
        ...mapGetters([
            "cartDetails",
            "cartValidate",
            "removeProtectionCartData",
            "cartUpdated",
            "uploadMediaResponse",
            "internalCheckoutResponse",
            "checkoutTotalResponse",
            "bindPromoCodeResponse",
            "unbindPromoCodeResponse",
            "addonPlanDetails",
        ]),
        cartItemsTotal() {
            let total = 0
            if (this.cartDetails?.items?.length > 0) {
                total = this.cartDetails.items.reduce((sum, item) => sum + parseFloat(item.item_total_amount), 0);
            }

            if (this.cartDetails?.bundles?.length > 0) {
                this.cartDetails.bundles.forEach(item => {
                    const amount = Number(item.bundle_amount) || 0;
                    const qty = Number(item.bundle_quantity) || 0;
                    total += (amount * qty);
                });
            }
            return total
        },
        modalCartCount() {
            let totalQty = 0;

            if (this.cartDetails?.items?.length > 0) {
                this.cartDetails.items.forEach(item => {
                    const qty = Number(item.item_quantity) || 0;
                    totalQty += qty;
                });
            }

            if (this.cartDetails?.bundles?.length > 0) {
                this.cartDetails.bundles.forEach(item => {
                    const qty = Number(item.bundle_quantity) || 0;
                    totalQty += qty;
                });
            }
            return totalQty
        },

    },


    watch: {
        bindPromoCodeResponse: function (data) {
            if (data.status == true) {
                this.$refs.voucherModalRef.closeModal();
                this.getCartDetails({ "is_show_promo_code": 1 })
            } else {
                this.$refs.voucherModalRef.setError(data.message);
            }

        },

        unbindPromoCodeResponse: function (data) {
            this.getCartDetails({ "is_show_promo_code": 1 })
        },
        removeProtectionCartData: function (data) {
            this.getCartDetails({ "is_show_promo_code": 1 })
            // if (this.selectedType == 'bundle') {
            //     this.upsertCart({
            //         "bundle_id": this.selectedPlan.id,
            //         "quantity": this.selectedPlan.quantity,
            //         "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
            //     })
            // }
            // else {
            //     this.upsertCart({
            //         "plan_id": this.selectedPlan.id,
            //         "quantity": this.selectedPlan.quantity,
            //         "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
            //     })
            // }

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                if (this.selectedType == 'bundle') {
                    this.upsertCart({
                        "bundle_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id": this.selectedPlan.partner_id ? this.selectedPlan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }

            }
            else {
                this.$confirmDialog.show({
                    title: "Action Required",
                    message: this.cartValidate.message,

                    onConfirm: () => {
                        this.removeBundle(this.cartValidate)
                    },
                });
            }

        },
        cartUpdated: function (data) {
            this.getCartDetails({ "is_show_promo_code": 1 })
        },

        cartDetails: function (data) {
            if (this.cartDetails.bundles.length == 0) {
                //this.$router.go(-1)
                this.$router.push({
                    path: "/plans",
                });
            }
            if (this.cartDetails.has_repair == false && (this.cartDetails.item_ids ?? []).length > 0) {
                this.removeProtectionItemCart({
                    "item_ids": this.cartDetails.item_ids ?? [],
                })
            }
            this.getCheckoutTotal({})

        },

        uploadMediaResponse: function (data) {
            this.dataForm['signature_image'] = this.uploadMediaResponse.file_name
            this.performCheckout()
        },

        internalCheckoutResponse: function (data) {
            if (data.status == true) {
                if (!this.$helper.isEmpty(this.internalCheckoutResponse?.body?.order_number)) {
                    this.getCartCount({})
                    this.$router.replace({
                        name: 'thankyou',
                        query: {
                            order_id: this.internalCheckoutResponse?.body?.order_number
                        }
                    })
                }
            } else {
                let msg = data?.message ?? "Something went wrong."
                this.$dialog.show({
                    title: "Unable to Continue Checkout",
                    text: msg,
                    buttonText: "Dismiss",
                    onConfirm: () => {

                    },
                });
            }
        },

        addonPlanDetails: function (data) {

            const modalEl = this.$refs.planDetailModal;
            if (this.modal) return
            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            document.documentElement.style.overflow = 'hidden';
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                document.documentElement.style.overflow = '';
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
            this.modal.show();
        },
    },

    mounted() {
        let user = JSON.parse(localStorage.getItem('user')) ?? {}


        if (Object.keys(user).length === 0) {
            window.location.replace("/login");
        }

        this.getCartDetails({ "is_show_promo_code": 1 })
        this.eventTrackUpdate({
            "event": "checkout-started"
        })
    },
    methods: {
        ...mapActions([
            "getCartDetails",
            "getCartCount",
            "upsertCart",
            "validateCart",
            "removeProtectionItemCart",
            "uploadMedia",
            "internalCheckout",
            "getCheckoutTotal",
            "bindPromoCode",
            "unbindPromoCode",
            "eventTrackUpdate"
        ]),

        toggleAccordion(step) {
            // prevent next step until Step 1 complete
            if ((step === 2 || step === 3) && !this.step1Completed) return;
            this.openAccordion = this.openAccordion === step ? null : step;
            this.$nextTick(() => {
                if (step == '1' && this.step1Completed) {
                    this.openAccordion = 1 // Start with Step 1 open
                    this.step1Completed = false
                    this.step2Completed = false
                    this.$refs.serviceDetailRef?.setData(this.dataForm)

                    this.$nextTick(() => {
                        this.$refs.serviceDetailsRef.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });

                } else if (step == '2' && this.step2Completed) {
                    this.$refs.billingInformationRef?.setData(this.dataForm)
                } else if (step == '3') {

                }
            })

        },
        handleStep1Complete(data) {
            this.dataForm = {}
            this.dataForm = data; // store it if needed later
            this.step1Completed = true;
            this.openAccordion = 2; // auto-open Step 2 after success
            this.$refs.billingInformationRef?.reset()
            this.eventTrackUpdate({
                "event": "service-detail"
            })
            // this.$nextTick(() => {
            //     const el = this.$refs.billingRef;
            //     if (el) {
            //         el.scrollIntoView({
            //             behavior: "smooth",
            //             block: "start",
            //         });

            //         setTimeout(() => {
            //             window.scrollBy({
            //                 top: -100,
            //                 behavior: "smooth",
            //             });
            //         }, 0);
            //     }
            // });
            this.$nextTick(() => {
                const el = this.$refs.billingRef;

                // Default offset
                let yOffset = 0;

                // Screen width check
                if (window.innerWidth <= 1275) {
                    yOffset = -100; // 100px gap
                }

                const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            });
        },

        handleStep2Complete(data) {
            this.dataForm['is_billing_address_same'] = data.is_billing_address_same;
            if (data.is_billing_address_same == '0')
                this.dataForm['billing_address'] = data.billing_address; // store it if needed later
            this.step2Completed = true;
            this.openAccordion = 3; // auto-open Step 2 after success
            this.$refs.paymentInformationRef?.reset()
            this.eventTrackUpdate({
                "event": "billing-information-completed"
            })

            this.$nextTick(() => {
                this.$refs.paymentRef.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            this.$nextTick(() => {
                if (window.innerWidth <= 1275) {
                    const el = this.$refs.paymentRef;

                    // Default offset
                    let yOffset = 0;

                    // Screen width check
                    yOffset = -100; // 100px gap

                    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({
                        top: y,
                        behavior: 'smooth'
                    });
                }
            });
        },

        handleStep3Complete(data) {
            this.dataForm['card_token'] = data.card_token;
            this.dataForm['card_holder_name'] = data.card_holder_name; // store it if needed later
            let formData = new FormData();
            formData.append("file", data.signature_image);
            formData.append("upload_type", "signature");
            formData.append("timestamp", (new Date()).getTime())

            this.uploadMedia(formData)
        },

        updateBundleCart(option, plan) {
            this.updateCartCall(option, plan, 'bundle', 'update')

        },
        updateCart(option, plan, type) {
            if (type == 'plan') {
                this.updateCartCall(option, plan, 'plan', '')
            }
            else {
                this.updateCartCall(option, plan, 'bundle', 'update')
            }
        },

        updateCartCall(option, plan, type = 'bundle', action = 'update') {

            this.selectedPlan = plan
            this.selectedType = type
            if (option == "cartUpdate") {
                this.isCartUpdate = true
            } else {
                this.isCartUpdate = false
            }

            if (option == 'decrement' || option == 'remove') {

                if (type == 'bundle') {
                    this.upsertCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }

            }
            else {

                if (type == 'bundle') {
                    this.validateCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }
                else {
                    this.validateCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id": plan.partner_id ? plan.partner_id : this.selectedProtectionPlan.partner_id

                    })
                }
            }

        },

        performCheckout() {
            this.internalCheckout(this.dataForm)
        },

        removeBundle(data) {
            // this.removeProtectionItemCart({
            //         "item_ids": this.cartDetails.item_ids ?? [],
            //     })
            // this.removeProtectionItemCart({
            //     "bundle_ids": data.bundle_ids,
            //     "plan_ids": data.plan_ids,
            // })
        },

        optionalCoverageClick() {
            this.isWatcherDisolve = false
            this.$refs.addonsModalRef.openModal();
        },

        openCoverageModal() {
            this.$refs.coverageModalRef.openModal()
        },

        openVoucherModal() {
            this.$refs.voucherModalRef.openModal();
        },

        handleVoucher(code) {
            let address = this.$refs.serviceDetailRef?.getAddress()
            let payLoad = {
                "promo_code_text": code
            }
            if (!this.$helper.isEmpty(address.city)) {
                payLoad['service_address'] = address
            }

            this.bindPromoCode(payLoad)
        },

        removeVoucher() {
            this.$dialog.show({
                title: "Remove Promo Code?",
                html: "Are you sure you want to remove this promo code from your cart?",
                onConfirm: () => {
                    this.unbindPromoCode({
                        promo_code_id: this.cartDetails.promo_code?.id
                    })
                },
            });
        },

        toggle() {
            this.isOpen = !this.isOpen;

            this.$nextTick(() => {
                this.contentHeight = this.isOpen
                    ? this.$refs.content.scrollHeight
                    : 0;
            });
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.8 - 50;
                }
                else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

        SSOButtonClicked() {
            if (this.$route.name == 'partnerCheckout') {
                this.$router.replace({name:'plans'})
            } else{
                let SSOLogin = JSON.parse(localStorage.getItem('SSOLogin')) ?? null
                window.location.replace(SSOLogin.failure)
            }
        }
    },
};
</script>
